import script from "./LoginLowResolution.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginLowResolution.vue?vue&type=script&setup=true&lang=js"

import "./LoginLowResolution.vue?vue&type=style&index=0&id=57806961&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57806961"]])

export default __exports__